import styled from '@emotion/styled';
import { ThemeType } from '@innovamat/glimmer-components';

type OrderStatus =
  | 'return'
  | 'processing'
  | 'shipped'
  | 'delivered'
  | 'cancel'
  | 'completed'
  | 'returned'
  | 'expand';

type OrderStatusTagProps = {
  orderStatus: OrderStatus;
  tag: string;
};

const getStatusColor = (status: OrderStatus, theme: ThemeType) => {
  console.log({ status });
  switch (status) {
    case 'return':
      return {
        bg: theme.tokens.color.alias.cm.bg['bg-warning'].value,
        text: theme.tokens.color.alias.cm.text['text-warning'].value,
      };
    case 'processing':
      return {
        bg: theme.tokens.color.alias.cm.bg['bg-info'].value,
        text: theme.tokens.color.alias.cm.text['text-info'].value,
      };
    case 'shipped':
      return {
        bg: theme.tokens.color.alias.cm.bg['bg-info'].value,
        text: theme.tokens.color.alias.cm.text['text-info'].value,
      };
    case 'delivered':
      return {
        bg: theme.tokens.color.alias.cm.bg['bg-success'].value,
        text: theme.tokens.color.alias.cm.text['text-success'].value,
      };
    case 'completed':
      return {
        bg: theme.tokens.color.alias.cm.bg['bg-success'].value,
        text: theme.tokens.color.alias.cm.text['text-success'].value,
      };
    case 'expand':
      return {
        bg: theme.tokens.color.alias.cm.bg['bg-info'].value,
        text: theme.tokens.color.alias.cm.text['text-info'].value,
      };
    default:
      return {
        bg: theme.tokens.color.alias.cm.bg['bg-neutral-subtle'].value,
        text: theme.tokens.color.alias.cm.text['text-subtle'].value,
      };
  }
};

const Tag = styled.span<{ orderStatus: OrderStatus }>`
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  background-color: ${({ orderStatus, theme }) =>
    getStatusColor(orderStatus, theme).bg};
  color: ${({ orderStatus, theme }) => getStatusColor(orderStatus, theme).text};
`;

function OrderStatusTag({
  orderStatus,
  tag,
}: OrderStatusTagProps): JSX.Element {
  return <Tag orderStatus={orderStatus}>{tag}</Tag>;
}

export { OrderStatusTag };
export type { OrderStatus };
